import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Modal as SemanticModal} from 'semantic-ui-react';

import {Button} from 'Common/Structure';

import './modal.scss';

const EclipseModal = ({
  children,
  closeText,
  destructive,
  footer,
  hideCloseButton,
  hideX,
  isLoading,
  onClose,
  onSubmit,
  scrolling,
  submitButtonDisabled,
  submitText,
  title,
  size,
  ...props
}) => {
  const originalFooter = (
    <SemanticModal.Actions>
      {!hideCloseButton && (
        <Button
          className="modal-close-btn"
          disabled={isLoading}
          floated="left"
          neutral
          onClick={onClose}
        >
          {closeText}
        </Button>
      )}

      <Button
        basic={destructive}
        className="modal-submit-btn"
        disabled={submitButtonDisabled || isLoading}
        loading={isLoading}
        negative={destructive}
        onClick={onSubmit}
        primary={!destructive}
      >
        {submitText}
      </Button>
    </SemanticModal.Actions>
  );

  return (
    <SemanticModal
      className="mhd--modal"
      closeIcon={!hideX}
      closeOnDimmerClick={!hideX}
      closeOnEscape={!hideX}
      onClose={onClose}
      open
      size={size === 'medium' ? null : size}
      {...props}
    >
      <SemanticModal.Header>{title}</SemanticModal.Header>

      <div className="mhd--divider-wrapper">
        <Divider />
      </div>

      <SemanticModal.Content scrolling={scrolling}>
        {children}
      </SemanticModal.Content>

      {footer || originalFooter}
    </SemanticModal>
  );
};

EclipseModal.defaultProps = {
  children: null,
  closeText: 'Cancel',
  destructive: false,
  footer: null,
  hideCloseButton: false,
  hideX: false,
  isLoading: false,
  onSubmit: null,
  scrolling: false,
  size: 'small',
  submitButtonDisabled: false,
  submitText: 'Submit',
  title: '',
};

EclipseModal.propTypes = {
  children: PropTypes.node,
  closeText: PropTypes.string,
  destructive: PropTypes.bool,
  footer: PropTypes.node,
  hideCloseButton: PropTypes.bool,
  hideX: PropTypes.bool,
  isLoading: PropTypes.bool,
  scrolling: PropTypes.bool,
  submitButtonDisabled: PropTypes.bool,
  submitText: PropTypes.node,
  title: PropTypes.string,

  // functions
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
};

export default EclipseModal;



// WEBPACK FOOTER //
// ./src/components/Common/Structure/EclipseModal.js